import * as mime from 'react-native-mime-types'; //
import { FILE_DELIMITER } from "./disbox-file-manager"; //
// Tambahkan showDirectoryPicker ke dalam import adapter
import { showSaveFilePicker, showDirectoryPicker } from "native-file-system-adapter"; //

export function getMimeType(name) {
    return mime.lookup(name) || 'application/octet-stream'; //
}

const VIDEO_EXTENSIONS = new Set(['mkv', 'mp4', 'm4v', 'webm', 'mov', 'avi', 'wmv', 'flv', 'm2ts', 'mts', 'ts', 'ogv', '3gp']);
const AUDIO_EXTENSIONS = new Set(['mp3', 'flac', 'm4a', 'aac', 'ogg', 'oga', 'opus', 'wav', 'wma', 'alac', 'aiff']);
const TEXT_EXTENSIONS = new Set([
    'txt', 'srt', 'ass', 'ssa', 'vtt', 'sub', 'nfo', 'md', 'markdown', 'json', 'log', 'csv', 'tsv', 'xml', 'yml', 'yaml',
    'ini', 'cfg', 'conf', 'toml', 'js', 'jsx', 'tsx', 'py', 'java', 'c', 'h', 'cpp', 'hpp', 'cs', 'go', 'rs', 'php', 'rb',
    'sh', 'bat', 'cmd', 'ps1', 'sql', 'html', 'htm', 'css', 'scss', 'lua', 'kt', 'swift', 'dart', 'properties', 'env',
    'm3u', 'm3u8', 'cue', 'diff', 'patch', 'tex', 'rtf', 'gitignore',
]);

function extensionOf(name) {
    const dot = String(name || '').lastIndexOf('.');
    return dot >= 0 ? name.slice(dot + 1).toLowerCase() : '';
}

// Jenis preview untuk sebuah nama file: 'image' | 'video' | 'audio' | 'pdf' | 'text' | null.
export function getPreviewKind(name) {
    const mimeType = getMimeType(name);
    const ext = extensionOf(name);
    if (mimeType.startsWith('image/')) return 'image';
    if (mimeType.startsWith('video/') || VIDEO_EXTENSIONS.has(ext)) return 'video';
    if (mimeType.startsWith('audio/') || AUDIO_EXTENSIONS.has(ext)) return 'audio';
    if (mimeType === 'application/pdf' || ext === 'pdf') return 'pdf';
    if (mimeType.startsWith('text/') || TEXT_EXTENSIONS.has(ext)) return 'text';
    return null;
}

export function isPreviewable(name) {
    return getPreviewKind(name) !== null;
}

export function isVideoFile(name) {
    return getPreviewKind(name) === 'video';
}

// Fungsi baru untuk memilih lokasi folder (digunakan untuk download folder)
export async function pickDirectoryLocation() {
    return await showDirectoryPicker();
}

export async function pickLocationAsWritable(suggestedName) {
    let pickerConfig = {
        suggestedName: suggestedName //[cite: 1]
    }
    if (suggestedName.includes(".")) {
        let extension = `.${suggestedName.split(".").pop()}`; //[cite: 1]
        const mimeType = getMimeType(suggestedName); //[cite: 1]
        pickerConfig.types = [{
            description: extension, //[cite: 1]
            accept: {[mimeType]: [extension] } //[cite: 1]
        }]
    }
    const fileHandler = await showSaveFilePicker(pickerConfig); //[cite: 1]
    return await (await fileHandler.createWritable()).getWriter(); //[cite: 1]
}

export function formatSize(bytes, decimals = 1) {
    if (bytes === 0) return '0 Bytes'; //[cite: 1]
    if (!bytes) return ''; //[cite: 1]
    const k = 1024; //[cite: 1]
    const dm = decimals < 0 ? 0 : decimals; //[cite: 1]
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']; //[cite: 1]
    const i = Math.floor(Math.log(bytes) / Math.log(k)); //[cite: 1]
    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i]; //[cite: 1]
}

export async function getAvailableFileName(fileManager, path, originalName) {
    const extension = originalName.includes(".") ? originalName.split(".").pop() : ""; //[cite: 1]
    const baseName = originalName.includes(".") ? originalName.substring(0, originalName.lastIndexOf(".")) : originalName; //[cite: 1]
    let name = baseName; //[cite: 1]
    let tryIndex = 1; //[cite: 1]
    for (;;) {
        const existing = await fileManager.getFile(`${path}${FILE_DELIMITER}${name}${extension ? `.${extension}` : ""}`);
        // File "placeholder" dari upload sebelumnya yang gagal di tengah jalan
        // (belum pernah punya `content`) tidak dianggap konflik - upload ulang
        // dengan nama sama langsung menimpanya, bukan jadi "nama (1)".
        if (!existing || (existing.type === 'file' && existing.content === undefined)) break;
        name = `${baseName} (${tryIndex})`; //[cite: 1]
        tryIndex++; //[cite: 1]
    }
    return name + (extension ? `.${extension}` : ""); //[cite: 1]
}